export const getContentType = (routeName: string | undefined): string => {
	if (routeName?.includes('PAGE')) return 'page';
	if (routeName?.includes('BLOG')) return 'blogpost';
	if (routeName?.includes('SPACE')) return 'space';
	return 'page';
};
